import { create } from 'zustand';
export const usePractitionerStore = create()((set, get) => ({
    practitioners: [],
    selectedPractitioner: null,
    showAllPractitioners: true,
    setPractitioners: (practitioners) => set(() => ({ practitioners })),
    setSelectedPractitioner: (practitioner) => set(() => ({ selectedPractitioner: practitioner })),
    setShowAllPractitioners: (showAllPractitioners) => set(() => ({ showAllPractitioners: showAllPractitioners })),
}));
